// src/components/Header/index.tsx (composant principal qui combine les deux)
import TopBar from './TopBar';
import MainHeader from './MainHeader';

const Header = () => {
  return (
    <>
      <TopBar />
      <MainHeader />
    </>
  );
};

export default Header;